import React, { FC } from "react";
import { useDispatcher } from "@hooks";
import { IAction } from "@dirootie-web/components-types";

export const withDispatcher = (
  WrappedComponent: FC<any>,
  type: "table" | "toolbar"|"button"
) => {
  const WithDispatcher = (props: any) => {
    const dispatcher = useDispatcher();
    if (type === "toolbar" || type === "table" || type === "button") {
      let { onAction, ...rest } = props;
      if (onAction === undefined) {
        onAction = (action: IAction) =>
          dispatcher[0](action);
      }
      return <WrappedComponent onAction={onAction} {...rest} />;
    }

    return <WrappedComponent {...props} />;
  };

  WithDispatcher.displayName = `withDispatcher(${
    WrappedComponent.displayName || WrappedComponent.name
  })`;
  return WithDispatcher;
};
